import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { scrollIntoViewForPageNavigation } from "../utils/scrollToHash";

const useScrollToTop = () => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (!hash) {
      window.scrollTo(0, 0);
      return;
    }

    // Defer geometry/visibility work until after the browser's layout pass so
    // getComputedStyle / offsetParent do not force a synchronous reflow.
    const id = window.requestAnimationFrame(() => {
      const element = document.getElementById(hash.substring(1));
      if (!element) return;
      const style = window.getComputedStyle(element);
      const visible =
        style.display !== "none" &&
        style.visibility !== "hidden" &&
        (element.offsetParent !== null || style.position === "fixed");
      if (visible) scrollIntoViewForPageNavigation(element);
    });
    return () => window.cancelAnimationFrame(id);
  }, [pathname, hash]);
};

export default useScrollToTop; 